import "./index.css";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./app.js";
import { ToastProvider } from "@/components/ui/toast.js";
import { SessionProvider, basePath } from "@/lib/session.js";

const root = document.getElementById("root");
if (!root) throw new Error("missing #root element");

createRoot(root).render(
  <BrowserRouter basename={basePath() || undefined}>
    <SessionProvider>
      <ToastProvider>
        <App />
      </ToastProvider>
    </SessionProvider>
  </BrowserRouter>
);
